
export type BadRequestErrorResponse = {
  error?: string;
  message?: string;
  timestamp?: string;
};
